import * as React from "react";
import { FunctionComponent, useEffect, useState } from "react";
import { FinishedGameSummary } from "@mancala/core";
import { useTranslation } from "react-i18next";
import { Context } from "../../context/context";
import { formatDate, getResultPillClass, getResultText } from "../../util/GameResultText";
import GameCard from "./GameCard";
import HomeSection from "./HomeSection";

const GAME_COUNT = 6;

// The most watched finished games.
const PopularGamesSection: FunctionComponent<{ context: Context }> = ({ context }) => {
    const { t, i18n } = useTranslation();
    const [games, setGames] = useState<FinishedGameSummary[] | undefined>(undefined);

    useEffect(() => {
        let disposed = false;
        context.gameStore.getPopularFinishedGames(GAME_COUNT)
            .then((popular) => !disposed && setGames(popular))
            .catch((error) => console.error("(Home) Could not load popular games", error));
        return () => { disposed = true; };
    }, []);

    if (!games) return <></>;
    return (
        <HomeSection title={t("PopularGames")} subtitle={t("MostWatched")} emptyText={t("NoGamesYet")}>
            {games.map((game) => (
                <GameCard
                    key={game.id}
                    id={game.id}
                    player1={game.player1}
                    player2={game.player2}
                    board={game.board}
                    status={getResultText(game, undefined, t)}
                    statusKind={getResultPillClass(game, undefined)}
                    details={`${formatDate(game.endedAt, i18n.language)} · ${t("Watching", { count: game.peakSpectators })}`} />
            ))}
        </HomeSection>
    );
};

export default PopularGamesSection;
